import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import '../styles/AdminNotPageFormList.css';
import Toast from './Toast';
import ButtonRegular from './ui/ButtonRegular';
import ButtonAdditional from './ui/ButtonAdditional';

const AdminNotPageFormList = () => {
    const [forms, setForms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [newFormId, setNewFormId] = useState(null);
    const [copiedId, setCopiedId] = useState(null);
    const [toast, setToast] = useState('');

    const fetchForms = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/forms`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                },
            });
            setForms(response.data);
        } catch (err) {
            setError('Błąd podczas ładowania formularzy');
        } finally {
            setLoading(false);
        }
    };

    const createNewForm = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/forms`, {}, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                },
            });
            setNewFormId(response.data._id);
            fetchForms();
            setToast('✅ Utworzono nowy formularz');
        } catch (err) {
            console.error('Błąd podczas tworzenia formularza', err);
            setToast('❌ Błąd podczas tworzenia formularza');
        }
    };

    const copyLink = (id) => {
        const fullUrl = `${window.location.origin}/form/${id}`;
        if (document.hasFocus()) {
            navigator.clipboard
                .writeText(fullUrl)
                .then(() => {
                    setCopiedId(id);
                    setTimeout(() => setCopiedId(null), 2000);
                    setToast('📋 Skopiowano link do schowka');
                })
                .catch((err) => {
                    console.error('Błąd podczas kopiowania linku:', err);
                    setToast('❌ Nie udało się skopiować linku');
                });
        } else {
            setToast('⚠️ Aktywuj okno przeglądarki, aby skopiować link.');
        }
    };

    useEffect(() => {
        fetchForms();
    }, []);

    // Pomocnicza funkcja do wyświetlania tekstu statusu
    const renderStatusText = (status) => {
        switch (status) {
            case 'closed':
                return 'Uzupełniony';
            case 'paid':
                return 'Opłacone';
            default:
                return 'W trakcie';
        }
    };

    return (
        <div className="admin-card">
            <h2 style={{ color: 'var(--accent-dark)' }}>Zarządzanie formularzami</h2>
            <ButtonRegular onClick={createNewForm}>➕ Utwórz nowy formularz</ButtonRegular>

            {newFormId && (
                <p>
                    Wygenerowano nowy formularz.{' '}
                    <Link to={`/form/admin/${newFormId}`}>Wprowadź produkty</Link>
                </p>
            )}

            {loading ? (
                <p>Ładowanie formularzy...</p>
            ) : error ? (
                <p>{error}</p>
            ) : (
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>Imię i nazwisko</th>
                            <th>Data utworzenia</th>
                            <th>Status</th>
                            <th>Akcje</th>
                            <th>Link</th>
                        </tr>
                    </thead>
                    <tbody>
                        {forms.map((form) => (
                            <tr key={form._id}>

                                <td>{form.customerData.firstName + ' ' + form.customerData.lastName}</td>
                                <td>{new Date(form.createdAt).toLocaleString()}</td>
                                
                                {/* 1. Zmiana wyświetlania statusu */}
                                <td>{renderStatusText(form.status)}</td>
                                
                                <td className="actions">
                                    <div className="action-group">
                                        {form.status === 'closed' && (
                                            // Status 'closed' -> Tylko Podgląd
                                            <Link className="btn-additional small" to={`/form/admin/show/${form._id}`}>Podgląd</Link>
                                        )}
                                        
                                        {form.status === 'paid' && (
                                            // Status 'paid' -> Podgląd i Inpost
                                            <>
                                                <Link className="btn-additional small" to={`/form/admin/show/${form._id}`}>Podgląd</Link>
                                                <Link className="btn-additional small" to={`/form/admin/delivery/${form._id}`}>Generowanie Inpost</Link>
                                            </>
                                        )}

                                        {form.status !== 'closed' && form.status !== 'paid' && (
                                            // Każdy inny status (np. w trakcie) -> Edycja
                                            <Link className="btn-regular small" to={`/form/admin/${form._id}`}>Edycja</Link>
                                        )}
                                    </div>
                                </td>
                                <td>
                                    <ButtonAdditional className="small" onClick={() => copyLink(form._id)}>📋 Skopiuj link</ButtonAdditional>
                                    {copiedId === form._id && (
                                        <p style={{ color: 'green' }}>Skopiowano!</p>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            {toast && <Toast message={toast} onClose={() => setToast('')} />}
        </div>
    );
};

export default AdminNotPageFormList;